// PRODUCT-26110 Phase 2B2: Vue 3 removed `vm.$children`/`vm.$vnode`, which the Tabs
// component previously used to discover its <Tab> children. Children now self-register
// with the parent through this provided registry (provide/inject), which is the Vue-3
// idiomatic replacement.

export const TABS_REGISTRY = 'tabsRegistry';

export interface TabMeta {
    id: string;
    name: string;
}

export interface TabsRegistry {
    // Kept in sync with the parent's active tab; a reactive field so that reads in each
    // Tab's `isActive` getter update reactively (a method closure did not track reliably
    // across the provide/inject boundary under Vue 3).
    activeId: string | undefined;
    register(tab: TabMeta): void;
    unregister(id: string): void;
}
